/* src/components/RequireRole.jsx */
/* ------------------------------ */

import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RequireRole = ({ roles, children }) => {
  const { user, isAuthenticated, loading } = useAuth();

  // ⏳ Esperar a que AuthContext termine de validar token
  if (loading) {
    return null; // o spinner
  }

  // 🔐 No autenticado → login (UNA SOLA VEZ)
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 🚫 Rol no permitido
  if (roles && !roles.includes(user.rol)) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default RequireRole;
